module.exports = __webpack_public_path__ + "static/img/pdf.5d558644.png";